import React from "react";
import { useNavigate, useRouteLoaderData } from "react-router-dom";
import LabeledEntry from "../../../helpers/LabeledEntry";
import { Button, Stack, styled } from "@mui/material";
import { testSessionLoader } from "../../../../loaders/helpers";
import useInfoSnackbar from "../../../../hooks/useInfoSnackbar";
import { imageDelete, imageView } from "../../../../api/image";
import ConfirmationContainer from "../../../helpers/ConfirmationContainer";
import ImageDisplay from "./ImageDisplay";
import ImageDownloadButton from "./ImageDownloadButton";

const StyledEntryContainer = styled(Stack)`
  gap: 1em;
  width: 80%;
  padding: 2em 0 4em;
`;

const StyledButtonContainer = styled(Stack)`
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 4em;
`;

const imageLoader = async (params) => {
  await testSessionLoader(params);
  const imageEntityId = params.params.id;
  const imageRes = await imageView(imageEntityId);
  const image = imageRes.data;
  return { image };
};

const Image = () => {
  const { image } = useRouteLoaderData("adminImage");
  const infoSnackbar = useInfoSnackbar();
  const navigate = useNavigate();

  const handleDeleteConfirmed = async () => {
    const res = await imageDelete(image.imageEntityId);
    if (res.code === "SUCCESS") {
      infoSnackbar.alertSuccess(res.message);
      navigate(-1);
    } else {
      infoSnackbar.alertError(res.message);
    }
  };

  const handleUpdateButtonClicked = () => navigate("update");

  const placeholder = "Not Specified";

  return (
    <>
      <StyledEntryContainer>
        <ImageDisplay image={image}/>
        <LabeledEntry
          label="Name"
          value={image.imageName}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Credit"
          value={image.imageCredit}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Label"
          value={image.imageLabel}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Type"
          value={image.imageType}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Url"
          value={image.imageUrl}
          placeholder={placeholder}
          link={image.imageUrl}
          isExternalLink
        />
        <LabeledEntry
          label="Create Date"
          value={image.createDate}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Last Modified"
          value={image.modifyDate}
          placeholder={placeholder}
        />
        <LabeledEntry
          label="Image Entity ID"
          value={image.imageEntityId}
          placeholder={placeholder}
        />
      </StyledEntryContainer>
      <StyledButtonContainer>
        {image.imageName && <ImageDownloadButton image={image}/>}
        <Button
          variant="contained"
          onClick={handleUpdateButtonClicked}
        >
          Update
        </Button>
        <ConfirmationContainer
          dialogTitle="Confirm Image Deletion"
          dialogMessage={`Are you sure that you want to delete this image${image.imageName
            ? `: "${image.imageName}"`
            : ""}?`}
          onConfirmed={handleDeleteConfirmed}
        >
          <Button
            variant="contained"
            color="error"
          >
            Delete
          </Button>
        </ConfirmationContainer>
      </StyledButtonContainer>
    </>
  );
};

export { imageLoader };
export default Image;